import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { Page } from '../models/paging/page';
import { PagedData } from '../models/paging/paged-data';
import { ServerData } from '../models/paging/server-data';
import { Job } from '../models/job';

@Injectable()
export class JobService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) {
  }

  public getTable(project: string, account: string, purchaseOrder: string, fromParent: boolean = false, activated: boolean = null, isScheduled = null): Promise<any> {
    return new Promise((resolve, reject) => {
      var params = "";
      params += "?project=" + project;
      params += "&account=" + account;
      params += "&purchaseOrder=" + purchaseOrder;
      params += "&fromParent=" + fromParent;
      params += "&activated=" + activated;
      params += "&isScheduled=" + isScheduled;

      //console.log(params);

      this.http.get<any>(environment.apiUrl + 'job/getTable' + params).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public get(id): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'job/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }
  public getById(id): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'job/getById?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public getJobTests(job): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'job/getjobtests?id=' + job.id).subscribe(data => {
        resolve(data);
        //console.log(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public addJob(job): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post<any>(environment.apiUrl + 'job/post', job).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        alert(error.error);
        reject();
      });
    });
  }

  public updateJob(job): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.put<any>(environment.apiUrl + 'job/put', job).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public duplicateJob(job): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.put<any>(environment.apiUrl + 'job/duplicateJob', job).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public assignTestForInvoicing(id): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'job/assigntestforinvoicing?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public approve(id,userId): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'job/approve?id=' + id + '&userId=' +userId).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }


  public getResults(page: Page, company_Id: number, location_Id: number, completed: boolean,
    technicianId: any, job_Num: any): Promise<PagedData<Job>> {
    const pagedData = new PagedData<Job>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&completed=' + completed;
      params += '&technicianId=' + technicianId;
      params += '&job_Num=' + job_Num;

      this.http.get<ServerData>(environment.apiUrl + 'job/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }
  
  public getReports(page: Page, company_Id: number, location_Id: number, completed: boolean,
    technicianId: any, job_Num:string): Promise<PagedData<Job>> {
    const pagedData = new PagedData<Job>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&completed=' + completed;
      params += '&technicianId=' + technicianId;
      params += '&job_Num=' + job_Num;

      this.http.get<ServerData>(environment.apiUrl + 'job/getReportTable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }


  public add(equip): Promise<Job> {
    return new Promise((resolve, reject) => {
      this.http.post<Job>(environment.apiUrl + 'job/PostFromWeb', equip).subscribe(data => {
        this.snotifyService.success("Successfuly added job");
        resolve(data);
      }, error => {
        this.snotifyService.error("failed to add job");

        //console.log(error);
        reject();
      });
    });
  }
  public update(equip): Promise<Job> {
    return new Promise((resolve, reject) => {
      this.http.post<Job>(environment.apiUrl + 'job/put', equip).subscribe(data => {
        this.snotifyService.success("Successfuly updated job");

        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public delete(id: string): Promise<Job> {
    return new Promise((resolve, reject) => {
      this.http.get<Job>(environment.apiUrl + 'job/delete?core_Id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }


  public getExcel(company_Id: number, location_Id: number ): Promise<any> {

    return new Promise((resolve, reject) => {

      let params = 'company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;


      this.http.get<any>(environment.apiUrl + 'job/getexcel?'+ params).subscribe(data => {
        let blob = this.convertBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);

      }, error => {
        reject();
      });
    });
  }

  convertBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }

}
